import TagManager from 'react-gtm-module';
import { getEnv } from 'lib/helpers/env';

const gtmSetup = (): void => {
  const gtmId = getGTMTagID();
  if (!gtmId) return;
  TagManager.initialize({ gtmId });
};

export const getGTMTagID = (): string | undefined => {
  const gmtTagID = getEnv('GTM_TAG_ID', getGTMFallback(getEnv('REACT_APP_AWS_ENV')));
  if (gmtTagID !== undefined && gmtTagID !== '') {
    return gmtTagID;
  }
  return undefined;
};

const getGTMFallback = (env: string | undefined): string | undefined => {
  switch (env) {
    // local dev shares the staging container so the GTM-driven cookie banner
    // can be tested locally (REACT_APP_AWS_ENV is 'development' on this instance)
    case 'staging':
      return 'GTM-N5BFZ7PF'; //OLD no longer visible in GA
      // return 'GTM-TPQ3LR77'; // New GA needs to be set up
    case 'sandbox':
      return undefined;
    case 'academy':
      return 'GTM-TTNMQ3R';
    case 'production':
      return 'GTM-NVN24M7';
    default:
      return undefined;
  }
};

export default gtmSetup;
